// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2Yok5","ranges":"BmiRanges_ranges__2DdpT"};